import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-deep-burgundy relative overflow-hidden">
      {/* Top border line */}
      <div className="w-full h-px bg-ancient-gold opacity-30"></div>

      {/* Botanical corner accent */}
      <div className="absolute top-8 right-8 w-32 h-32 opacity-[0.08]">
        <svg viewBox="0 0 100 100" className="w-full h-full text-ancient-gold">
          <path
            d="M50 10 Q60 30 50 50 Q30 60 10 50 M50 10 Q70 20 90 10 M10 50 Q20 70 10 90"
            stroke="currentColor"
            fill="none"
            strokeWidth="0.5"
          />
        </svg>
      </div>

      <div className="max-w-7xl mx-auto px-8 lg:px-16 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <img 
              src="https://public.readdy.ai/ai/img_res/ba7ef960-0c6d-41b7-b8de-4ad297b17548.png" 
              alt="House of Selkara" 
              className="h-16 w-auto mb-6"
            />
            <p className="font-garamond text-moon-ivory text-sm leading-relaxed">
              Where women come to be seen at the level of their soul and called forward into the most sovereign version of themselves.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-cormorant text-ancient-gold tracking-widest-plus text-sm mb-6">
              NAVIGATE
            </h4>
            <div className="flex flex-col gap-3">
              <Link to="/" className="font-garamond text-moon-ivory text-sm hover:text-ancient-gold transition-colors duration-300 cursor-pointer">
                Home
              </Link>
              <Link to="/about" className="font-garamond text-moon-ivory text-sm hover:text-ancient-gold transition-colors duration-300 cursor-pointer">
                About
              </Link>
              <Link to="/the-method" className="font-garamond text-moon-ivory text-sm hover:text-ancient-gold transition-colors duration-300 cursor-pointer">
                The Method
              </Link>
              <a href="/#offerings" className="font-garamond text-moon-ivory text-sm hover:text-ancient-gold transition-colors duration-300 cursor-pointer">
                Offerings
              </a>
              <a href="/#contact" className="font-garamond text-moon-ivory text-sm hover:text-ancient-gold transition-colors duration-300 cursor-pointer">
                Contact
              </a>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-cormorant text-ancient-gold tracking-widest-plus text-sm mb-6">
              CONNECT
            </h4>
            <div className="flex flex-col gap-3">
              <a href="mailto:hello@houseofselkara.com" className="font-garamond text-moon-ivory text-sm hover:text-ancient-gold transition-colors duration-300 cursor-pointer">
                hello@houseofselkara.com
              </a>
              <div className="flex gap-4 mt-4">
                <a href="#" className="text-ancient-gold hover:text-blush-ash transition-colors duration-300 cursor-pointer" aria-label="Instagram">
                  <i className="ri-instagram-line text-xl"></i>
                </a>
                <a href="#" className="text-ancient-gold hover:text-blush-ash transition-colors duration-300 cursor-pointer" aria-label="Facebook">
                  <i className="ri-facebook-circle-line text-xl"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-ancient-gold/20">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="font-garamond text-moon-ivory/60 text-xs">
              © 2025 House of Selkara. All rights reserved.
            </p>
            <p className="font-cormorant text-ancient-gold text-xs italic tracking-wider">
              Founded by Lola Selkara
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}